module.exports = __webpack_public_path__ + "img/linked-bank-account-new.9d67cac8.svg";